// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../bos/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#printPDFFile .details_block {
  background-color: lavender;
  color: blue;
  padding: 5px 10px 10px 10px;
}
#printPDFFile input[type=checkbox]:not(old),
#printPDFFile input[type=radio]:not(old) {
  width: 1.5em;
  height: 1.5em;
  cursor: pointer;
  vertical-align: bottom;
}
#printPDFFile .bg-radio {
  margin-left: 10px !important;
}
#printPDFFile .bg-check {
  margin-left: 50px !important;
}
#printPDFFile .printWindow {
  z-index: 15000;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
}
#printPDFFile .iframePortlet {
  display: flex;
  flex-grow: 1;
}
#printPDFFile .k-window-titlebar {
  display: none !important;
}
#printPDFFile .k-window.k-widget {
  top: 0 !important;
  left: 0 !important;
  height: calc(100% - 5px) !important;
  width: calc(100% - 5px) !important;
}
#printPDFFile .format-label {
  font-size: 14px;
  margin: 0px 5px;
  cursor: pointer;
}
#printPDFFile .hide {
  display: none;
}
#printPDFFile #browser-no-support {
  text-align: center;
  font-size: 18px;
  padding: 20px 0px;
  color: red;
}`, "",{"version":3,"sources":["webpack://./../gui/src/components/print/printpdf.scoped.scss"],"names":[],"mappings":"AACI;EACI,0BAAA;EACA,WAAA;EACA,2BAAA;AAAR;AAEI;;EAEI,YAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;AAAR;AAEI;EACI,4BAAA;AAAR;AAEI;EACI,4BAAA;AAAR;AAEI;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;AAAR;AAEI;EACI,aAAA;EACA,YAAA;AAAR;AAEI;EACI,wBAAA;AAAR;AAGI;EACI,iBAAA;EACA,kBAAA;EACA,mCAAA;EACA,kCAAA;AADR;AAII;EACI,eAAA;EACA,eAAA;EACA,eAAA;AAFR;AAII;EACI,aAAA;AAFR;AAKI;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;AAHR","sourcesContent":["#printPDFFile{\n    .details_block{\n        background-color: lavender; \n        color: blue;\n        padding: 5px 10px 10px 10px;\n    }  \n    input[type=checkbox]:not(old),\n    input[type=radio]:not(old){\n        width : 1.5em;\n        height : 1.5em;\n        cursor : pointer;\n        vertical-align : bottom;\n    }\n    .bg-radio{\n        margin-left: 10px !important;\n    }\n    .bg-check{\n        margin-left: 50px !important;\n    }\n    .printWindow{\n        z-index: 15000;\n        width: 100%;\n        height: 100%;\n        display: flex;\n        flex-flow: column;\n    }\n    .iframePortlet{\n        display: flex;\n        flex-grow: 1;\n    }\n    .k-window-titlebar {\n        display: none !important;\n    }\n    \n    .k-window.k-widget {\n        top: 0 !important;\n        left: 0 !important;\n        height: calc(100% - 5px) !important;\n        width: calc(100% - 5px) !important;\n    }\n    \n    .format-label{\n        font-size : 14px;\n        margin : 0px 5px;\n        cursor : pointer;\n    }\n    .hide{\n        display : none;\n    }\n    \n    #browser-no-support{\n        text-align: center;\n        font-size: 18px;\n        padding: 20px 0px;\n        color: red;\n    }   \n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
